export const CONFIGURACOES_LOADING = 'CONFIGURACOES_LOADING';
export const CONFIGURACOES_DATA = 'CONFIGURACOES_DATA';